import { createSlice } from '@reduxjs/toolkit'
import { getVendors, trackUserApiActions } from '../../apis'

export const apiLoggerSlice = createSlice({
    name: 'apiLogger',
    initialState: {
      trackApiData: [],
      trackDataSuccess: false,
      isLoading: false,
      error: '',

    },
    reducers: {
      setTrackData: (state, action) => {
        state.trackApiData = action.payload.data
      },
      addTrackData: (state, action) => {
        state.trackApiData = [ ...state.trackApiData, action.payload.data]
      },
      clear: (state, action) => {
        state[action.payload.key] = action.payload.value;
      }
    },
    extraReducers: (builder) => {
      builder.addCase(trackUserApiActions.pending, (state, action) => {
        state.isLoading = true;
        state.trackDataSuccess = false
      })
      builder.addCase(trackUserApiActions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = '';
        state.trackDataSuccess = true
      })
      builder.addCase(trackUserApiActions.rejected, (state, action) => {
        state.error = action.payload.message
        state.isLoading = false;
      })
    }
})

export const {setTrackData, addTrackData, clear} = apiLoggerSlice.actions

export default apiLoggerSlice.reducer